var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { ConfirmToolbar } from '../../common/Toolbar';
import { Body } from '../../root/PageRouter';
import { useRouter } from '../../../context/router-context';
import Loading from '../../common/Loading';
import SecondaryToolbarTitle from '../../common/SecondaryToolbarTitle';
import CalendarInput from '../../common/CalendarInput';
import { useUpdateOptionGrantMutation, useUpdateOptionGrantPageQuery, } from '../../../__generated__/graphql';
import { List, ListItemCurrencyInput, ListItemIntegerInput, ListItemSwitch, ListItemTextArea, } from '@bootstraplabs/bsw-common-react';
function Toolbar(props) {
    return (_jsxs(_Fragment, { children: [_jsx(ConfirmToolbar, __assign({ disabled: props.disabled, onClick: props.onClick }, { children: props.children }), void 0),
            _jsx(SecondaryToolbarTitle, { children: "Edit Option Grant" }, void 0)] }, void 0));
}
export default function UpdateOptionGrant() {
    // Router
    var match = useRouter().match;
    // GraphQL query
    var _a = useUpdateOptionGrantPageQuery({
        variables: { optionGrantId: match.params.optionGrantId },
    }), data = _a.data, loading = _a.loading;
    var optionGrant = data && data.optionGrant;
    var resetIssuedAt = function () { return new Date().toISOString().slice(0, 10); };
    // State
    var _b = useState(''), purchasePrice = _b[0], setPurchasePrice = _b[1];
    var _c = useState(''), exercisePrice = _c[0], setExercisePrice = _c[1];
    var _d = useState(''), quantity = _d[0], setQuantity = _d[1];
    var _e = React.useState(true), typeDate = _e[0], setTypeDate = _e[1];
    var _f = useState(''), issuedAtDate = _f[0], setIssuedAtDate = _f[1];
    var _g = useState(false), calendarIsOpen = _g[0], setCalendarIsOpen = _g[1];
    var _h = React.useState(''), remarks = _h[0], setRemarks = _h[1];
    // Initialize state
    useEffect(function () {
        if (optionGrant) {
            setPurchasePrice(String(optionGrant.purchasePrice));
            setExercisePrice(String(optionGrant.exercisePrice));
            setQuantity(String(optionGrant.quantity));
            if (!optionGrant.issuedAt) {
                setTypeDate(false);
            }
            setIssuedAtDate(String(optionGrant.issuedAt));
            setRemarks(optionGrant.remarks);
        }
    }, [optionGrant]);
    // Helper
    function dateConfirm(datePicked, date) {
        if (datePicked) {
            return date;
        }
        return null;
    }
    function onClickTypeDate() {
        setTypeDate(!typeDate);
        setIssuedAtDate(resetIssuedAt);
    }
    // GraphQL mutation
    var updateOptionGrant = useUpdateOptionGrantMutation({
        variables: {
            input: {
                optionGrantId: match.params.optionGrantId,
                purchasePrice: Number(purchasePrice),
                exercisePrice: Number(exercisePrice),
                quantity: Number(quantity),
                issuedAt: dateConfirm(typeDate, issuedAtDate),
                remarks: remarks.trim(),
            },
        },
    })[0];
    var disabled = Number(quantity) <= 0 ||
        Number(quantity) > 2147483647 ||
        Number(purchasePrice) < 0 ||
        Number(purchasePrice) > 1000000000000 ||
        Number(exercisePrice) < 0 ||
        Number(exercisePrice) > 1000000000000 ||
        remarks.trim().length > 1000;
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0),
                _jsx(Loading, {}, void 0)] }, void 0));
    }
    if (!optionGrant) {
        throw new Error('Update option grant query failed (option grant not found)');
    }
    return (_jsxs(_Fragment, { children: [_jsx(Toolbar, __assign({ disabled: disabled, onClick: updateOptionGrant }, { children: optionGrant.optionPlan.shareClass.organization.name }), void 0),
            _jsx(Body, { children: _jsxs(List, { children: [_jsx(ListItemIntegerInput, { labelWidth: 140, label: "Quantity", value: quantity, onChange: setQuantity }, void 0),
                        _jsx(ListItemCurrencyInput, { labelWidth: 140, label: "Purchase Price", value: purchasePrice, onChange: setPurchasePrice }, void 0),
                        _jsx(ListItemCurrencyInput, { labelWidth: 140, label: "Exercise Price", value: exercisePrice, onChange: setExercisePrice }, void 0),
                        _jsx(ListItemSwitch, { primary: "Enable Issued Date", wrapPrimary: true, checked: typeDate, onClick: function () { return onClickTypeDate(); } }, void 0),
                        typeDate ? (_jsx(CalendarInput, { label: "Issued At", date: issuedAtDate, onChange: function (date) { return setIssuedAtDate(date.slice(0, 10)); }, isCalendarOpen: calendarIsOpen, showCalendar: setCalendarIsOpen }, void 0)) : null,
                        _jsx(ListItemTextArea, { labelWidth: 200, label: "Remarks", value: remarks, onChange: setRemarks }, void 0)] }, void 0) }, void 0)] }, void 0));
}
//# sourceMappingURL=UpdateOptionGrant.js.map